var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column app",style:(_vm.frame)},[_c('router-view'),_c('Feed',{ref:"feed"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }